/// <reference path="../../_ext/Editors/LaborGridEditor.ts" />

namespace TabAurous.Retail {
    import fld = POSApprovalReturnLaborRow.Fields;
    @Serenity.Decorators.registerClass()
    export class POSApprovalReturnLaborEditor extends _Ext.LaborGridEditor<POSApprovalReturnLaborRow> {
         protected getLocalTextPrefix() { return POSApprovalReturnLaborRow.localTextPrefix; } 

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as POSApprovalReturnItemsDialog).CalculateTotals();
                }
            });

            this.slickGrid.onRender.subscribe(() => {
                this.SetInlineLookupEditor();
            });

        }

        setMasterValues() {
            this.LaborListId = (this.parentDialog as POSApprovalReturnItemsDialog).LaborMarkup;
            this.LaborMarkup = (this.parentDialog as POSApprovalReturnItemsDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as POSApprovalReturnItemsDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as POSApprovalReturnItemsDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as POSApprovalReturnItemsDialog).TransDate;
            this.PartyId = (this.parentDialog as POSApprovalReturnItemsDialog).PartyId;
        } 

        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.LabourRate).format = num;
            Q.first(columns, x => x.field === fld.MarkUp).format = num;

            var CalcOn = Q.first(columns, x => x.field === fld.CalcOnId);
            CalcOn.referencedFields = [fld.CalcOnId];
            CalcOn.format = ctx => {
                var width = (ctx.column.width) as number - 10;
                return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="LCalcId' + ctx.row + '" title="Applicable On" />';
            };

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        public SetInlineLookupEditor() {
            // course of all the lines present in the grid
            var Items = this.view.getItems();
            if (Items.length > 0)
                for (let Item in Items) {
                    this.InlineLookup(Item, Items);
                }
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.ProcessSelectGrid;

            buttons.push({
                title: "Apply Labor Charges",
                cssClass: "add-button",
                onClick: () => {
                    this.setMasterValues();
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        Width: 400,
                        preSelectedKeys: this.view.getItems().map(k => k.ProcessId)
                    });

                    pickerDialog.onSuccess = (selectedLabor: any[]) => {
                        let filteredLabor: any[];
                        filteredLabor = selectedLabor.filter(t => { return !Q.any(this.view.getItems(), n => n.ProcessId == t.ProcessId) });
                        var self = this;
                        var LaborDetails: POSApprovalReturnLaborRow[];

                        let Item = (self.parentDialog as POSApprovalReturnItemsDialog).getItem();
                        LaborDetails = RateHelper.ApplyPurchseLabour(Item, filteredLabor, self.RateListId, self.LaborMarkup, self.TransDate);

                        for (let LaborDetail of LaborDetails) {
                            LaborDetail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = LaborDetail;
                            this.view.addItem(LaborDetail);
                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }
        public setData(labors: any[]) {
            this.view.setItems([]);
            for (let LaborDetail of labors) {
                LaborDetail[this.getIdProperty()] = "`" + this.nextId++;
                var x = LaborDetail;
                this.view.addItem(LaborDetail);
            }

        }
    }
}